import React from "react";

import {
    FiCheckCircle,
    FiEdit2,
    FiEye,
    FiSlash,
    FiTrash2,
} from "react-icons/fi";


const BusinessTableActions = ({
    business,

    loading =
        false,

    onView =
        null,

    onEdit =
        null,

    onActivate =
        null,

    onSuspend =
        null,

    onDelete =
        null,

    showView =
        true,

    showEdit =
        false,

    showStatus =
        true,

    showDelete =
        false,
}) => {

    /*
    |--------------------------------------------------------------------------
    | STATUS
    |--------------------------------------------------------------------------
    */

    const status =
        String(
            business?.status ||
            ""
        )
            .trim()
            .toUpperCase();


    const isActive =
        status ===
        "ACTIVE";


    /*
    |--------------------------------------------------------------------------
    | UI
    |--------------------------------------------------------------------------
    */

    return (

        <div className="platform-business-actions">

            {/*
            |--------------------------------------------------------------------------
            | VIEW
            |--------------------------------------------------------------------------
            */}

            {showView &&
            typeof onView ===
                "function" ? (

                <button
                    type="button"
                    title="View Business"
                    disabled={
                        loading
                    }
                    onClick={() =>
                        onView(
                            business
                        )
                    }
                >

                    <FiEye />

                </button>

            ) : null}


            {/*
            |--------------------------------------------------------------------------
            | EDIT
            |--------------------------------------------------------------------------
            */}

            {showEdit &&
            typeof onEdit ===
                "function" ? (

                <button
                    type="button"
                    title="Edit Business"
                    disabled={
                        loading
                    }
                    onClick={() =>
                        onEdit(
                            business
                        )
                    }
                >

                    <FiEdit2 />

                </button>

            ) : null}


            {/*
            |--------------------------------------------------------------------------
            | ACTIVATE / SUSPEND
            |--------------------------------------------------------------------------
            */}

            {showStatus ? (

                isActive ? (

                    typeof onSuspend ===
                    "function" ? (

                        <button
                            type="button"
                            className="suspend"
                            title="Suspend Business"
                            disabled={
                                loading
                            }
                            onClick={() =>
                                onSuspend(
                                    business
                                )
                            }
                        >

                            <FiSlash />

                        </button>

                    ) : null

                ) : (

                    typeof onActivate ===
                    "function" ? (

                        <button
                            type="button"
                            className="activate"
                            title="Activate Business"
                            disabled={
                                loading
                            }
                            onClick={() =>
                                onActivate(
                                    business
                                )
                            }
                        >

                            <FiCheckCircle />

                        </button>

                    ) : null

                )

            ) : null}


            {/*
            |--------------------------------------------------------------------------
            | DELETE
            |--------------------------------------------------------------------------
            */}

            {showDelete &&
            typeof onDelete ===
                "function" ? (

                <button
                    type="button"
                    className="delete"
                    title="Delete Business"
                    disabled={
                        loading
                    }
                    onClick={() =>
                        onDelete(
                            business
                        )
                    }
                >

                    <FiTrash2 />

                </button>

            ) : null}

        </div>

    );

};


export default BusinessTableActions;